import styled from 'styled-components';

import Icon from './Icon';

const Wrapper = styled.div`
  width: 26px;
  height: 26px;
`;

const iconStyle = {
  width: '20px',
  height: '20px',
};

const Spinner = () => {
  return (
    <Wrapper>
      <Icon name={Icon.SPINNER} style={iconStyle} rotate />
    </Wrapper>
  );
};

export default Spinner;
